import { Button } from "@/components/Button"
import { SidebarCards } from "@/components/Layout/SidebarAccount/Cards"
import { SidebarAccountLang } from "@/components/Layout/SidebarAccount/Lang"
import { SidebarAccountUser } from "@/components/Layout/SidebarAccount/User"
import { Skeleton } from "@/components/Skeleton"
import {
  ClientType,
  ECardType,
  getApiDataPromise,
  selectUser,
  useActiveCards,
  useIbanList,
  useStoreClient,
  useTopUpStore,
} from "@usher/pe-client-front-end-lib"
import clsx from "clsx"
import { useEffect, useMemo, useState } from "react"
import { FormattedMessage } from "react-intl"
import { useHistory } from "react-router-dom"

type Props = {
  isOpen: boolean
  toggleSidebar: () => void
  onClose: VoidFunction
}

export const SidebarAccount = ({ isOpen, toggleSidebar, onClose }: Props) => {
  const { activeCards, loading, isCardActive } = useActiveCards()
  const { client_type, iban_active, card_active } = useStoreClient(selectUser)
  const { data: ibans } = useIbanList()
  const hasIban = (ibans ?? []).length > 0
  const history = useHistory()
  const isCorporateAccount = client_type === ClientType.Coroporate
  const cardsList = useMemo(() => activeCards.filter((x) => x.card_type !== "3"), [activeCards])
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, setPayoutsCards] = useState([])
  const [isPayoutsLoading, setIsPayoutsLoading] = useState(false)
  const hasActiveCards = (activeCards ?? []).length > 0
  const setCardType = useTopUpStore((state) => state.setCardType)
  const navigateToTopUp = (path: string, cardType: string) => {
    setCardType(cardType)
    history.push(path)
  }
  useEffect(() => {
    setIsPayoutsLoading(true)
    getApiDataPromise({ card_type: "3" }, "exchange", "get_user_cards")
      .then((res) => {
        setPayoutsCards(res.data ?? [])
      })
      .finally(() => {
        setIsPayoutsLoading(false)
      })
  }, [])

  return (
    <div className="w-auto">
      <div className={`btn-account-sidebar${isOpen ? " is-active" : ""}`} onClick={toggleSidebar} />
      <div
        className={clsx("account-sidebar", isOpen && "active")}
        onClick={(e) => {
          if (e.target === e.currentTarget) {
            onClose()
          }
        }}
      >
        <SidebarAccountUser onAction={onClose} />
        <SidebarAccountLang />
        {loading ? (
          <div className="account-sidebar_btn">
            <Skeleton height={40} />
            <Skeleton height={40} />
          </div>
        ) : (
          <div className="mb-[30px] flex flex-col md:flex-row gap-2.5 flex-wrap child:w-full child:whitespace-nowrap" onClick={onClose}>
            <Button>
              <FormattedMessage id="buy_crypto" />
            </Button>
            {!loading && isCardActive && (
              <Button color="secondary" to="/cards/create">
                Order New Card
              </Button>
            )}
            {isCardActive && hasActiveCards && (
              <Button color="secondary" to={"/topup/by-crypto"}>
                <FormattedMessage id="top-up-payout-button" />
              </Button>
            )}
            {isCardActive && (
              <Button color="secondary" onClick={() => navigateToTopUp("/topup/by-crypto", String(ECardType.OwnCard))}>
                Make Payout to Own Card
              </Button>
            )}
            {hasIban && iban_active && (
              <Button color="secondary" to="/iban/topup">
                Top Up Bank Account
              </Button>
            )}
            {iban_active && (
              <Button color="secondary" to="/iban/order">
                Open Bank Account
              </Button>
            )}
          </div>
        )}
        {!isCorporateAccount && card_active && (
          <>
            <div className="account-sidebar_cards mb-4" onClick={onClose}>
              <SidebarCards cards={cardsList} fetching={loading} />
            </div>
          </>
        )}
        {hasIban && iban_active && (
          <div className="mb-4 pt-0" onClick={onClose}>
            <SidebarCards cards={ibans} fetching={isPayoutsLoading} msg="no-active-ibans" />
          </div>
        )}
        {/* <div className="account-sidebar_footer">
          <div className="account-sidebar_footer-title">
            <FormattedMessage id="instant" />
          </div>
          <div className="account-sidebar_footer-desc">
            <FormattedMessage id="just-use" />
          </div>
          <Button variant="outlined" className="mt-[20px] w-full">
            <FormattedMessage id="try" />
          </Button>
        </div> */}
        <div className="account-sidebar_footer" onClick={onClose}>
          <div className="account-sidebar_footer-title">
            <FormattedMessage id="join" />
          </div>
          <div className="account-sidebar_footer-desc">
            <FormattedMessage id="earn" />
          </div>
          <Button variant="outlined" className="mt-[20px] w-full">
            <FormattedMessage id="join-us" />
          </Button>
        </div>
        <div className="account-sidebar_footer" onClick={onClose}>
          <div className="account-sidebar_footer-title">
            <FormattedMessage id="help-you" />
          </div>
          <div className="account-sidebar_footer-desc">
            <FormattedMessage id="ask" />
          </div>
          {/* onClick={() => window.open(process.env.REACT_APP_PATH_HOME + "faq.html")} */}
          <Button variant="outlined" className="mt-[20px] w-full">
            <FormattedMessage id="get_support" />
          </Button>
        </div>
      </div>
    </div>
  )
}
